
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/SubmitTip.css';

const SubmitTip = () => {
  return (
    <>
      <Helmet>
        <title>Submit a Tip | Redbox Global</title>
        <meta
          name="description"
          content="Submit confidential news tips and information securely to Redbox Global. Your identity can remain anonymous."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://redboxglobal.com/submit-a-tip" />
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Submit a Tip</h1>
          <p className="page-subtitle">
            Help Redbox Global report accurate, impactful journalism.
            Tips can be submitted confidentially.
          </p>
        </div>

        <div className="page-content">
          <div className="tip-layout">
            {/* Left content (editorial text) */}
            <div className="tip-info">
              <h2>What to Share</h2>
              <p>
                We welcome tips related to business, finance, markets,
                corporations, public policy, technology, and global affairs.
              </p>

              <h2>Confidentiality</h2>
              <p>
                Your identity will be protected. You may submit information
                anonymously. Please avoid including sensitive personal data
                unless necessary.
              </p>

              <h2>Secure Communication</h2>
              <p>
                For highly sensitive information, please use secure and
                encrypted communication channels.
              </p>
            </div>

            {/* Right content (form) */}
            <div className="tip-form-wrapper">
              <form className="tip-form">
                <label>
                  Name (optional)
                  <input type="text" placeholder="Your name" />
                </label>

                <label>
                  Email (optional)
                  <input type="email" placeholder="you@email.com" />
                </label>

                <label>
                  Subject
                  <input type="text" placeholder="Brief summary of the tip" required />
                </label>

                <label>
                  Tip Details
                  <textarea
                    placeholder="Provide as much detail as possible"
                    rows="6"
                    required
                  />
                </label>

                <button type="submit" className="submit-btn">
                  Submit Tip
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubmitTip;
